import { Grid } from "@mui/material";
import PostGradoService from "../../services/PostGradoService";
import { useEffect, useState } from "react";
//import FinanDesglose from "../Common/FinanDesglose";
import { ListVoidDesgloseYear, ListVoidDesgloseYearIntCent, ProyFinanDesgloseDTO, ProyFinanIntCentDesgloseDTO } from "../../interfaces/ProyectosDTOS/ProyectoFinanDesglose";

const postGradoService = new PostGradoService();

export default function ComboTest () {
  //#region Variables
  const [desgloseData, setDesgloseData] = useState<Array<ProyFinanDesgloseDTO>>([]);
  const [desgloseDataDollarCent, setDesgloseDataDollarCent] = useState<Array<ProyFinanIntCentDesgloseDTO>>([]);
  const [ready,setReady] = useState(false);
  //#endregion    
  //#region Funciones
      function generarDesglose(years:Array<number>){
        setDesgloseData(ListVoidDesgloseYear(years,0,0));
        setDesgloseDataDollarCent(ListVoidDesgloseYearIntCent(years,0,0));
        //console.log(desgloseData)
      }      
  //#endregion    

  //#region UseEffect
      useEffect(() => {
        console.log('Iniciamos');
        generarDesglose([2023,2024,2022,2025]);
        setReady(true);
      },[]);
  //#endregion
    
      return (  
        <Grid container spacing={2} sx={{mt:6}}>
            <Grid item xs={12}>
              {ready ? 
                <>
                <>Nada</>
                </>                
                :
                <>Waiting...</>
              }
            </Grid>
        </Grid>             
      );
  }